import { useState } from "react";
import type { SaleRecordExpanded } from "../../types/sales";
import ExpandableSaleRow from "../ExpandableSalesRow";


const SalesTable: React.FC<{ sales: SaleRecordExpanded[] }> = ({ sales }) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div className="bg-white rounded-lg shadow-md overflow-x-auto">
      <table className="w-full text-sm text-left">
        <thead className="border-b bg-primary text-white">
          <tr>
            <th className="text-left py-2 px-4">Date</th>
            <th className="px-4 py-2">Store</th>
            <th className="px-4 py-2">Payment</th>
            <th className="px-4 py-2">Revenue</th>
            <th className="px-4 py-2">Cost</th>
            <th className="px-4 py-2">Profit</th>
            <th></th>
          </tr>
        </thead>

        {sales.length > 0 ? (
            <tbody>
            {sales.map((sale) => {
                const isOpen = expandedId === sale.id;

                return (
                <>
                    <tr
                      key={sale.id}
                      className="border-b hover:bg-gray-50 cursor-pointer"
                      onClick={() =>
                          setExpandedId(isOpen ? null : sale.id)
                      }
                    >
                    <td className="px-4 py-3">
                        {new Date(sale.createdAt).toDateString()}
                    </td>
                    <td className="px-4 py-2">{sale.store}</td>
                    <td className="px-4 py-2">{sale.paymentMethod}</td>
                    <td className="px-4 py-2">GHS {sale.amount}</td>
                    <td className="px-4 py-2">GHS {sale.cost}</td>
                    <td className="text-green-700 px-4 py-2">
                        GHS {(sale.amount - sale.cost).toFixed(2)}
                    </td>
                    <td className="text-primary">
                        {isOpen ? "−" : "+"}
                    </td>
                    </tr>

                    {isOpen && <ExpandableSaleRow sale={sale} />}
                </>
                );
            })}
            </tbody>
        ) : (
            <tr>
              <td colSpan={7} className="py-6 text-center text-gray-500">
                No sales records available
              </td>
            </tr>
        )}

      </table>
    </div>
  );
};

export default SalesTable;
